<template>
  <v-card class="rounded-lg d-flex align-center fill-height" elevation="0">
    <div class="w-100 d-flex pa-2 py-4 justify-space-between align-center">
      <v-btn
        @click="setShopSelectWithCounter('')"
        class="rounded-xl"
        :elevation="0"
        color="white"
        :disabled="shops?.length == 0"
      >
        <v-icon color="orange">mdi-chevron-right</v-icon>
      </v-btn>
      <v-card elevation="0" class="w-100">
        <div
          v-if="loading"
          class="d-flex"
          style="flex-wrap: wrap; gap: 10px; justify-content: center"
        >
          <v-btn v-for="i in 5" :key="i" :elevation="0">
            <template v-slot:loader> </template>
          </v-btn>
        </div>
        <div
          v-else
          class="d-flex"
          style="flex-wrap: wrap; gap: 10px; justify-content: center"
        >
          <p v-if="shops?.length == 0 && !loading">
            {{
              admin
                ? " در مجتمع شما کیوآری وجود ندارد!"
                : "شما در مجتمع تجاری عضویت ندارید"
            }}
          </p>
          <v-btn
            v-else
            v-for="(shop, i) in shops"
            :color="shopSelecte.qr_id === shop.qr_id ? '#FF4400' : null"
            :key="i"
            :class="`${
              shopSelecte.qr_id === shop.qr_id ? 'text-white' : 'text-black'
            }`"
            :elevation="0"
            @click="setShopSelect(shop.qr_id, i)"
            >{{ admin ? shop.setting.name : shop.identifier }}</v-btn
          >
        </div>
      </v-card>
      <v-btn
        @click="setShopSelectWithCounter('add')"
        class="rounded-xl"
        :elevation="0"
        color="white"
        :disabled="shops?.length == 0"
      >
        <v-icon color="orange">mdi-chevron-left</v-icon>
      </v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "commercialTags",
  props: {
    qrland: Number,
    value: [Object, Array, null],
    admin: Boolean,
  },
  data() {
    return {
      counter: null,
      shops: [],
      loading: false,
    };
  },

  watch: {
    qrland(val) {
      if (val) {
        this.fetch();
      }
    },
  },

  computed: {
    shopSelecte: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  mounted() {
    this.fetch();
  },
  methods: {
    async fetch() {
      (this.loading = true),
        await this.$api
          .get(
            this.admin
              ? `${this.$qrApi}/v1/commercial/${this.qrland}`
              : `${this.$qrApi}/v1/commercial/user?qr=${this.qrland}`,
          )
          .then((data) => {
            this.shops = this.admin ? data.data.info : data.data.data;
            this.shopSelecte = this.admin ? data.data.info : data.data.data[0];
          })
          .finally(() => (this.loading = false));
    },
    setShopSelect(id, index) {
      if (id) {
        this.shopSelecte = this.shops.find((item) => item.qr_id === id);
        this.counter = index;
      }
    },
    setShopSelectWithCounter(type) {
      if (type === "add") {
        this.counter++;
        if (this.counter == this.shops.length) {
          this.counter = 0;
          this.shopSelecte = this.shops[this.counter];
        } else {
          this.shopSelecte = this.shops[this.counter];
        }
      } else {
        this.counter = this.counter - 1;
        if (this.counter === -1) {
          this.counter = this.shops.length - 1;
          this.shopSelecte = this.shops[this.counter];
        } else {
          this.shopSelecte = this.shops[this.counter];
        }
      }
    },
  },
};
</script>

<style></style>
